"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const ShopifyColored = createSVGIcon(
  <>
    <path
      d="M19.954 4.614a.22.22 0 0 0-.207-.19c-.087 0-1.797-.034-1.797-.034s-1.434-1.383-1.572-1.538c-.138-.138-.415-.104-.519-.069l-.725.224a5 5 0 0 0-.346-.846c-.501-.968-1.261-1.486-2.16-1.486-.069 0-.121 0-.19.017-.034-.034-.051-.069-.086-.086-.397-.415-.898-.622-1.503-.605-1.158.035-2.315.881-3.266 2.367-.656 1.054-1.157 2.367-1.313 3.386-1.33.415-2.263.709-2.298.709-.673.207-.691.224-.777.864-.035.484-1.797 14.116-1.797 14.116L16.188 24l6.41-1.59c-.018 0-2.626-17.675-2.644-17.796m-5.563-1.365a42 42 0 0 0-1.141.363c0-.587-.086-1.417-.345-2.108.881.138 1.313 1.141 1.486 1.745m-1.918.588c-.777.242-1.624.501-2.471.76.242-.916.691-1.814 1.244-2.419.208-.225.501-.466.83-.605.345.674.414 1.624.397 2.264M10.883.778c.277 0 .501.052.692.191a3.1 3.1 0 0 0-.899.708c-.743.795-1.313 2.021-1.538 3.214-.708.224-1.399.432-2.021.622C7.532 3.629 9.104.83 10.883.778"
      fill="#95BF47"
    />
    <path
      d="M19.75 4.425c-.086 0-1.796-.035-1.796-.035s-1.435-1.382-1.573-1.538a.28.28 0 0 0-.19-.086V24l6.41-1.589-2.626-17.796c-.035-.121-.138-.19-.225-.19"
      fill="#5E8E3E"
    />
    <path
      d="m12.632 7.725-.743 2.782s-.829-.38-1.814-.311c-1.451.086-1.451 1.002-1.451 1.227.086 1.244 3.352 1.52 3.541 4.44.139 2.298-1.209 3.87-3.179 3.991-2.349.121-3.645-1.261-3.645-1.261l.501-2.125s1.313.984 2.35.915a.916.916 0 0 0 .898-.984c-.104-1.625-2.764-1.521-2.937-4.199-.138-2.246 1.33-4.509 4.578-4.717 1.262-.086 1.901.242 1.901.242"
      fill="#fff"
    />
  </>,
  "ShopifyColored",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
